<template>
  <!-- 联系我们-->
  <section :id='id' class="newsletter-area feature-area section-padding2"   style='background-image: url("static/assets/images/train/bg03.png");background-size: 100% 100%;'>
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="section-top text-center">
            <h2 class='borderCDF'>联系我们</h2>
          </div>
        </div>
      </div>
      <div class="">
        <div class='row'>
          <div class="col-lg-4" style='text-align: left;' >
            <div class='inputLable'>称呼 <span v-show='isName' style='color: rgb(127 4 4);'>请填写内容</span></div>
            <input style='width: 100%;' type="text" v-model="info.name" placeholder="怎么称呼您" required>
          </div>
          <div class="col-lg-4" style='text-align: left;'>
            <div class='inputLable'>公司 <span v-show='isCompany' style='color: rgb(127 4 4);'>请填写内容</span></div>
            <input style='width: 100%;' type="text" v-model="info.company" placeholder="您的公司名称" required>
          </div>
          <div class="col-lg-4" style='text-align: left;'>
            <div class='inputLable'>联系方式 <span v-show='isMobile' style='color: rgb(127 4 4);'>请填写内容</span></div>
            <input style='width: 100%;' type="text" v-model="info.mobile" placeholder="联系方式" required>
          </div>
          <div class="col-lg-12">
            <div class='inputLable'>您的需求 <span v-show='isDemand' style='color: rgb(127 4 4);'>请填写内容</span></div>
            <input style='width: 100%;height:70px;' v-model="info.demand"  placeholder="您想解决什么问题" required></input>
          </div>
          <div class="col-lg-12 textCenter">
            <button type="submit" @click='addBusiness' class="contactUs-btn">提交</button>
          </div>
          <div class="col-lg-12 textCenter" style='height: 30px;margin-top: 10px;'>
            <p v-show='isOk'>提交成功</p>
          </div>
        </div>


      </div>
    </div>
  </section>
</template>

<script>
  export default{
    props:{id:null},
    data(){
      return{
        info:{
          name:'',// 名称
          company:'',// 公司名称
          mobile:'',// 联系方式
          demand:'',// 需求
        },
        isName:0,
        isCompany:0,
        isMobile:0,
        isDemand:0,
        isOk:0
      }
    },
    methods:{
      addBusiness(){
        console.log('===========')
        if(!this.info.name){this.isName = 1}else{this.isName=0}
        if(!this.info.company){this.isCompany = 1}else{this.isCompany=0}
        if(!this.info.mobile){this.isMobile = 1}else{this.isMobile=0}
        if(!this.info.demand){this.isDemand = 1}else{this.isDemand=0}
        if(this.isName==0&&this.isCompany==0&&this.isMobile==0&&this.isDemand==0){
          let info = this.info
          this.$http({
            method:'post',
            url:'http://123.57.1.182/website/api/website/business/add',
            data:info
          }).then((res) => {
            console.log(res)
            if(res.data.code == 200){
              // this.introduceInfo = res.data.rows
              this.isOk = 1
              this.info={
                name:'',// 名称
                company:'',// 公司名称
                mobile:'',// 联系方式
                demand:'',// 需求
              }
              setTimeout(()=>{
                this.isOk = 0
              },2000)
            }
          })
        }
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// contact.vue?2f398588